import React from 'react';
import styled from '@emotion/native';
import { Title } from './styledComponents';
import { green } from '@/shared/styles/colors';
import { LoraText } from '@/shared/components/StyledText';
import useExploreStore from '@/stores/useExploreStore';
import { Gender } from '@/shared/types/generated';

interface GenderOption {
  label: string;
  value: Gender | null;
}

const genderOptions: GenderOption[] = [
  { label: 'FEMALE', value: Gender.Female },
  { label: 'MALE', value: Gender.Male },
  { label: 'NON-BINARY', value: Gender.NonBinary },
  { label: 'SHOW ALL', value: null },
];

const GenderFilters = () => {
  const { filters, setFilters } = useExploreStore();
  const selected = filters.gender;

  const handleSelect = (value: Gender | null) => {
    setFilters({ gender: value });
  };

  return (
    <Container>
      <Title>Filter by Gender Preference:</Title>
      {genderOptions.map((option) => (
        <RadioRow key={option.label}>
          <RadioButton onPress={() => handleSelect(option.value)}>
            <RadioOuter>
              {selected === option.value && <RadioInner />}
            </RadioOuter>
          </RadioButton>
          <RadioLabel selected={selected === option.value}>
            {option.label}
          </RadioLabel>
        </RadioRow>
      ))}
    </Container>
  );
};

const Container = styled.View({
  marginBottom: 32,
});

const RadioRow = styled.View({
  flexDirection: 'row',
  alignItems: 'center',
  marginBottom: 15,
});

const RadioButton = styled.TouchableOpacity({
  marginRight: 16,
});

const RadioOuter = styled.View({
  width: 35,
  height: 35,
  borderRadius: 20,
  borderWidth: 1,
  borderColor: green,
  alignItems: 'center',
  justifyContent: 'center',
});

const RadioInner = styled.View({
  width: 20,
  height: 20,
  borderRadius: 12,
  backgroundColor: green,
});

const RadioLabel = styled(LoraText)<{ selected: boolean }>(({ selected }) => ({
  fontSize: 14,
  letterSpacing: 4,
  color: green,
  fontWeight: selected ? 'bold' : 'normal',
}));

export default GenderFilters;
